import { subclass, property } from "@arcgis/core/core/accessorSupport/decorators";
import Widget from "@arcgis/core/widgets/Widget";
import { tsx } from "@arcgis/core/widgets/support/widget";

import WMTSLayer from '@arcgis/core/layers/WMTSLayer'

import { Layer } from './layers'
import { appConfig} from './main'

const CSS = {
    base: "sublayerselectorwidget"
};

@subclass("esri.widgets.PresetPanel")
class SublayerselectorWidget extends Widget {

    @property()
    layer?: Layer

    @property()
    queryFunction: (() => Promise<string[][]>) | null = null

    @property()
    max: number = 100

    @property()
    goToParams: any = {}

    @property()
    queryResults: string[][] = []

    @property()
    selected: string | null = null

    @property()
    isLoading: boolean = false

    constructor(params: any) {
        super(params);
        this.query = this.query.bind(this)
        this.loadSubLayer = this.loadSubLayer.bind(this)
        this.loadSubLayerJQuery = this.loadSubLayerJQuery.bind(this)
        this.handleQueryResults = this.handleQueryResults.bind(this)
    }

    postInitialize() {
        this.query()
    }

    loadSubLayerJQuery(e: any) {
        const name = $(e.target).attr('name');
        if(name)
            this.loadSubLayer(name)
    }

    loadSubLayer(id: string) {
        if(!this.layer) return;

        if (this.layer.layerType == "WMTSLayer") {
            (this.layer.esriLayer as WMTSLayer).activeLayer.id = id;
            (this.layer.esriLayer as WMTSLayer).refresh();
            this.selected = id
        } else {
            // somehow more generically select a sublayer
        }
    }

    handleQueryResults(results: string[][]) {
        this.queryResults = results.slice(0, this.max)
        this.isLoading = false
        if (results.length > 0) {
            this.loadSubLayer(results[0][0])
        }
    }

    handleQueryError(error: any) {
        this.isLoading = false
    }

    query() {

        if (this.queryFunction) {
            this.queryFunction().then(this.handleQueryResults, this.handleQueryError)
            this.isLoading = true

            // @ts-ignore
        } else if (this.layer.esriLayer.sublayers && this.layer.esriLayer.sublayers.length > 0) {
            this.isLoading = true
            let results: string[][] = []
            // @ts-ignore
            for (let sublayer of this.layer.esriLayer.sublayers.items) {
                results.push([sublayer.id, sublayer.title])
            }
            this.handleQueryResults(results)
        } else {
            console.log("This control doesn't support the Layer Type " + this.layer?.layerType)
        }

    }

    render() {
        let resultHTMLObjects = []
        let results: string[] = []
        let icon: string = "esri-icon-radio-unchecked"
        if (this.queryResults) {
            for (let i : number = 0; i < this.queryResults.length; i++) {
                results = this.queryResults[i]

                if (results[0] == this.selected) {
                    icon = "esri-icon-radio-checked"
                } else {
                    icon = "esri-icon-radio-unchecked"
                }

                resultHTMLObjects.push(
                    <div class="row row-no-margin" style="margin-top: 15px" key={Math.floor(Math.random() * 1000)}>
                        <div class="col-md-12">
                            { results[1] }
                            <span name={results[0]} style="float: right; font-size: 20px; margin-top: auto;" class={icon} onclick={this.loadSubLayerJQuery}></span>
                        </div>
                    </div>
                )
            }
        }

        let loadingHtml = <div></div>
        
        if (this.isLoading) {
            loadingHtml = <div class="spinner-icon" style="margin: auto"></div>
        }

        return (
            <div class={this.classes(CSS.base)} key="presetpanel-container">
                <div class="row row-no-margin" key="presetpanel-options">
                    <label for="searchText">
                        Available Sublayers: 
                    </label>
                </div>
                {loadingHtml }
                {resultHTMLObjects}
            </div>
        );
    }
}

export default SublayerselectorWidget